import React from 'react';
import { addDaysToDate, formatDateRange, formatDateKey } from './dateUtils';
import style from './CalendarNavigation.module.sass';

const CalendarNavigation = ({ startDate, onPrevious, onNext, onToday, onDatePick, onShowChangeLog }) => {
  const endDate = addDaysToDate(startDate, 12); // 2 weeks minus Sunday

  const handleDateChange = (e) => {
    const date = new Date(e.target.value + 'T00:00:00');
    if (!isNaN(date)) onDatePick(date);
  };

  return (
    <div className={style.navigation}>
      <button className={style.navButton} onClick={onPrevious}>
        &larr; Previous Week
      </button>
      <button className={style.todayButton} onClick={onToday}>
        Today
      </button>
      <span className={style.dateRange}>
        {formatDateRange(startDate, endDate)}
      </span>
      <input
        type="date"
        className={style.datePicker}
        value={formatDateKey(startDate)}
        onChange={handleDateChange}
      />
      <button className={style.navButton} onClick={onNext}>
        Next Week &rarr;
      </button>
      <button className={style.changeLogButton} onClick={onShowChangeLog}>
        Change Log
      </button>
    </div>
  );
};

export default CalendarNavigation;
